import React from 'react';

const Input = ({
  name,
  label,
  field,
  required,
  erros,
  ...props
}) => {
  return (
    <div className="form-group" style={{ width: '100%' }}>
        {name && <label htmlFor={name}>
            {label} {required ? <span className="required"> *</span> : '' }
        </label>}
      <input
        name={name}
        className="form-control"
        {...field}
        {...props}
      />
      <span style={{ color: 'red' }}>{erros}</span>
    </div>
  );
};

export default Input;
